module.exports = __webpack_public_path__ + "img/content-not-form.ac65cd16.svg";